<template>
  <v-dialog
    transition="dialog-bottom-transition"
    persistent
    lazy
    scrollable
    :value="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="(val) => $emit('update:show', val)"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-layout
          align-center
          justify-center
        >
          <span class="headline">
            {{ $t('shareVideoOnSocialMediaChooseFormat') }}
          </span>
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            icon
            @click="onAborted()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout
          wrap
          justify-center
          align-baseline
        >
          <div
            v-for="tvspot in spotsToShareOnPlatform"
            :key="tvspot.id"
            class="ma-2 clickable"
            @click="onChosen(tvspot)"
          >
            <v-layout
              column
              align-center
            >
              <video-thumbnail
                :tvspot="tvspot"
                :title="tvspot.tvformat.name"
                outline-on-hover
              />
              <div class="grey--text text--darken-1 nowrap">
                {{ tvspot.tvformat.name }}
              </div>
            </v-layout>
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {sortVideoObjectsByPreferredFormatOrder} from '@/utils';

import shareOnSocialMedia from '@/mixins/shareOnSocialMedia';

import VideoThumbnail from '@/components/VideoThumbnail';

export default {
  components: {
    VideoThumbnail,
  },
  mixins: [shareOnSocialMedia],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    bundle: {
      type: Object,
      required: true,
    },
    platform: {
      type: String,
      required: true,
      validator: function (mode) {
        return mode === 'facebook' || mode === 'instagram';
      },
    },
  },
  computed: {
    spotsToShareOnPlatform() {
      let tvspots = [];
      if (this.platform === 'facebook') {
        tvspots = this.spotsToShareOnFacebook;
      } else if (this.platform === 'instagram') {
        tvspots = this.spotsToShareOnInstagram;
      }

      return sortVideoObjectsByPreferredFormatOrder(tvspots, {
        widthAttr: 'width',
        heightAttr: 'height',
      });
    },
  },
  watch: {
    show: function (show) {
      if (show && this.spotsToShareOnPlatform.length === 1) {
        console.log(
          '[DEBUG] Only one clip supported to share, skipping dialog to choose one'
        );
        const onlySpot = this.spotsToShareOnPlatform[0];
        this.onChosen(onlySpot);
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },
    onAborted() {
      this.closeDialog();
      this.$emit('aborted');
    },
    onChosen(tvspot) {
      this.closeDialog();
      this.$emit('chosen', tvspot);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChooseSpotToShareOnSocialMediaDialog.vue